import { useMemo } from 'react'
import { t } from '@lingui/macro'
import WeeklyBarChart from '@/components/ui/charts/WeeklyBarChart'
import { Category, Periodicity } from '@/core/api/statistics'
import { useGetEstablishmentConsultationsStatisticsQuery } from '@/core/services/statistics'
import { ChartSkeleton, getWeekRangeString } from '@/features/statistics'

type WeeklyConsultationsProps = {
  establishmentId: string
}

export function WeeklyConsultations({ establishmentId }: WeeklyConsultationsProps) {
  const { data, isLoading } = useGetEstablishmentConsultationsStatisticsQuery({
    category: [Category.status, Category.type],
    establishment: establishmentId,
    periodicity: [Periodicity.WEEKLY],
  })

  const chart = useMemo(() => {
    if (!data) return

    return {
      labels: data?.periodicity?.[Periodicity.WEEKLY]?.chart.labels.map((label) => getWeekRangeString(label)) ?? [],
      datasets: data?.periodicity?.[Periodicity.WEEKLY]?.chart.datasets ?? [],
    }
  }, [data])

  if (isLoading) return <ChartSkeleton />

  return <WeeklyBarChart chartData={chart} title={t`Weekly Consultations`} label={t`Global View`} />
}
